import React, { useEffect, useState } from "react";
import CustomEventList from "../../reusable/CustomEventList";
import moment from "moment";
import { getUpcomingEvents } from "../../../utils/ApiFunctions";
import { useDispatch } from "react-redux";
import { linkActions } from "../../store";
import Loader from "../../reusable/Loader";
import NoData from "../../reusable/NoData";

function UpcomingEvents(props) {
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState("");
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const getAllEvents = async () => {
    const resp = await getUpcomingEvents();
    if (resp) {
      setTotalPages(resp.totalPages);
      const temp = resp.data.events?.map((event) => ({
        _id: event._id,
        name: event.eventName,
        date: moment(event.date).format("YYYY-MM-DD"),
        // time: `${moment(event.fromTime).format("HH:mm")}-${moment(
        //   event.toTime
        // ).format("HH:mm")}`,
        time : `${event.fromTime} - ${event.toTime}`,
        assignedTo: event.contactPerson,
        employees: event.noOfParticipants,
        format: event.eventFormat,
        court: event.court.map((c) => `${c.name}`).join(", "),
        status : event.status,
        paymentStatus: event.paymentStatus,
      }));
      setEvents(temp);
      setLoading(false);
    }
    setLoading(false);
  };
  useEffect(() => {
    getAllEvents();
    dispatch(linkActions.setTo("/admin/eventheader/upcoming"));
  }, [page]);

  return (
    <>
      {loading && <Loader />}
      {!loading && !events[0] &&
        <NoData title={"No Upcoming Events"} subtitle={"Create event to be added to the list"}/>
      }
      {!loading && events[0]&&(
        <CustomEventList
          responsive={'tableTabletAdminEvents'}
          events={events}
          eventstate={"upcoming"}
          // page={page}
          // setPage={setPage}
          // totalPages={totalPages}
        />
      )}
    </>
  );
}

export default UpcomingEvents;
